import React, { useMemo } from 'react'
import { Typography, Paper, DialogTitle, useTheme, useMediaQuery } from '@mui/material'
import { Box } from '@mui/system'
import { FormProvider, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { AddTariffForm, AddTariffFormData, createAddTariffSchema } from '../../../tariffs/components/add-tariff/AddTariffForm'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Trans } from 'react-i18next'

/** Add tariff step component with add tariff form component */
export const AddTariffDialogStep: React.FC = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { t } = useCustomTranslation()
  const addTariffSchema = useMemo(() => createAddTariffSchema(t), [t])
  const form = useForm<AddTariffFormData>({
    resolver: zodResolver(addTariffSchema),
    defaultValues: {
      tariffName: '',
      tariffGridPrice: '',
      tariffSolarPrice: '',
      tariffDischargePrice: '',
      startDate: null,
      endDate: null,
    },
  })

  return (
    <Box>
      <Typography>{t('emobility.tour.add-tariff-title')}</Typography>

      <Trans i18nKey="emobility.tour.add-tariff-content" components={{ strong: <strong /> }} />

      {!isMobile && (
        <Paper
          component="div"
          sx={theme => ({
            mt: 2,
            pointerEvents: 'none',
            opacity: 0.9,
            boxShadow: '0 0 0 2px rgba(0,0,0,0.15), 0 8px 20px rgba(0,0,0,0.3)', // More dramatic shadow
            overflow: 'hidden',
            transform: 'scale(0.95)',
            filter: 'grayscale(5%)',
            backgroundColor: '#fff', // Optional: enforce light bg in dark UIs
            padding: 4,
            paddingBottom: 6,
          })}
        >
          <FormProvider {...form}>
            <DialogTitle sx={{ padding: 0, mb: 2 }}>{t('emobility.tariffs.addTariffTitle')}</DialogTitle>
            <AddTariffForm currencySymbol={'€'} />
          </FormProvider>
        </Paper>
      )}
    </Box>
  )
}
